import { useState, useEffect } from 'react';
import { ApiGet } from '../Api';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'moment/locale/ko';
import { useLocation } from 'react-router-dom';

const SctCalendar = () => {
  const [events, setEvents] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get('type');

  useEffect(() => {
    document.title = 'SCT CALENDAR';
    const date = moment(new Date()).format('YYYY-MM');
    Inquiry(date);
  }, []);
  
  async function Inquiry(date) {
    const response = await ApiGet(`${process.env.REACT_APP_API_DOMAIN}sct/calendar?date=${date}&type=${type}`);
    if (response !== null && response.ok) {
      const json = await response.json();

      const colors = [
        '#1E90FF',
        '#00BFFF',
        '#87CEFA',
        '#4682B4',
        '#5F9EA0',
        '#6495ED',
        '#4169E1'
      ];

      const newEvents = [];
      for (const [index, event] of json.entries()) {
        const color = colors[index % colors.length];
        if (event.start !== event.end) {
          const newEventStart = {
            title: `${event.title}(시작)`,
            start: new Date(event.start),
            end: new Date(event.start),
            style: { backgroundColor: color }
          };
          const newEventEnd = {
            title: `${event.title}(종료)`,
            start: new Date(event.end),
            end: new Date(event.end),
            style: { backgroundColor: color }
          };
          newEvents.push(newEventStart);
          newEvents.push(newEventEnd);
        } else {
          const newEvent = {
            title: event.title,
            start: new Date(event.start),
            end: new Date(event.end),
            style: { backgroundColor: color }
          };
          newEvents.push(newEvent);
        }
      }
      setEvents(newEvents);
    }
  }

  moment.locale('ko');
  const localizer = momentLocalizer(moment);

  const holidays = [
    '2025-01-01',
    '2025-03-01',
    '2025-05-05',
    '2025-06-06',
    '2025-08-15',
    '2025-10-03',
    '2025-12-25'
  ];
  const dayPropGetter = (date) => {
    const formattedDate = moment(date).format('YYYY-MM-DD');
    const isHoliday = holidays.includes(formattedDate);
    const isSunday = date.getDay() === 0;

    if (isHoliday || isSunday) {
      return { style: { backgroundColor: '#ffe6e6' } };
    }

    return {};
  };

  const Toolbar = (toolbar) => {
    const handleNavigate = (action) => {
      let newDate;
      if (action === 'PREV') newDate = moment(toolbar.date).subtract(1, 'month').toDate();
      else if (action === 'NEXT') newDate = moment(toolbar.date).add(1, 'month').toDate();

      setEvents([]);
      Inquiry(moment(newDate).format('YYYY-MM'));
      toolbar.onNavigate(action);
    };

    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ width: 400, display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
          <button onClick={() => handleNavigate('PREV')} style={{ width: 30, height: 30, fontSize: '16px', cursor: 'pointer' }}>
            {'◀'}
          </button>
          <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
            {moment(toolbar.date).format('YYYY년 MM월')}
          </span>
          <button onClick={() => handleNavigate('NEXT')} style={{ width: 30, height: 30, fontSize: '16px', cursor: 'pointer' }}>
            {'▶'}
          </button>
        </div>
      </div>
    );
  };

  const eventPropGetter = (event) => {
    return {
        style: event.style || {}, // 이벤트에 지정된 스타일 사용
    };
  };

  return (
    <div style={{ height: 'calc(100vh - 90px)', padding: '20px', paddingBottom: '70px' }}>
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor='start'
        endAccessor='end'
        defaultView='month'
        views={['month']}
        popup={true}
        formats={{
          monthHeaderFormat: (date, culture, localizer) => localizer.format(date, 'YYYY년 MM월', culture),
          dayHeaderFormat: (date) => moment(date).format('MM월 DD일 dddd'),
          dateFormat: 'D',
        }}
        components={{
          toolbar: Toolbar
        }}
        //dayPropGetter={dayPropGetter}
        eventPropGetter={eventPropGetter}
      />
    </div>
  );
};

export default SctCalendar;